module.exports = __webpack_public_path__ + "static/assets/25ed681e2be779886d68064346029712.png";